var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
function Video(_a) {
    return (_jsx("div", __assign({ style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "600px",
            height: "350px",
        } }, { children: _jsx("iframe", { src: "https://www.loom.com/embed/7300c1393cb04215b12a121a817367d1", allowFullScreen: true, title: "Embedded LoomVideo", style: {
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "15px",
            } }) })));
}
export default Video;
